module.exports = __webpack_public_path__ + "static/media/Press-4.89b0f6fb.png";